// Central SEO configuration for joyn Association Management Software
export const SITE = {
  name: "joyn Association Management Software",
  url: "https://www.joynams.com",
  urlCA: "https://www.joynams.ca",
  defaultImage: "https://www.joynams.com/brand/hero-conference.jpg",
  twitter: "@joynAMS",
  linkedin: "https://www.linkedin.com/company/joynams",
};

// Per-route metadata (path -> { title, description }).
// Content mirrors the on-page copy; used by <Seo> and the build-time prerender.
export const PAGE_SEO = {
  "/": {
    title: "joyn Association Management Software | All-in-One AMS",
    description:
      "joyn is an all-in-one, cloud-based Association Management Software (AMS) for associations, trade associations and AMCs. Membership, conferences, continuing education, mobile app, reporting and AI on one platform.",
  },
  "/products": {
    title: "Products & Services — joyn Association Management Software",
    description:
      "Explore joyn's modular AMS: membership, conferences, submissions & reviews, continuing education, mobile app, e-posters, job board, surveys, reporting, integrations & SSO. Turn on what you need and add modules as you grow.",
  },
  "/ai": {
    title: "joyn AI — AI Built Into Your AMS",
    description:
      "Practical AI built into joyn: an Engagement Score to predict retention, customizable Dashboard Widgets, and Ask Joyn — get plain-language answers about your association's data, with no data scientists or new tools.",
  },
  "/who-we-serve": {
    title: "Who We Serve — joyn Association Management Software",
    description:
      "Built alongside associations, for associations. joyn serves professional associations, trade associations, medical & scientific societies, and association management companies (AMCs).",
  },
  "/support": {
    title: "Client Support — joyn Association Management Software",
    description:
      "More than a vendor — your technology partner. Every joyn client gets a dedicated Customer Success Manager, turnkey onboarding, and custom training. Most clients go live in just 3–5 weeks.",
  },
  "/about": {
    title: "About joyn Association Management Software — All-in-One Cloud AMS Since 2013",
    description:
      "joyn is an all-in-one cloud AMS serving associations, trade associations and AMCs since 2013, with offices in the USA, Canada and India and clients across the globe.",
  },
  "/contact": {
    title: "Contact joyn Association Management Software",
    description:
      "Let's talk about your association. Tell us what you're working on and our team will show you exactly how joyn can help you grow. Offices in the USA, Canada & India.",
  },
};
